import { Routes } from '@angular/router'

import { FeatureType, RouteGuard, RouteUtil } from '../shared'
import { BlueStakesLogsComponent } from './blue-stakes-log/blue-stakes-logs.component'
import { DamagedUtilityLogComponent } from './damaged-utility-log/damaged-utility-log.component'
import { PunchListItemsComponent } from './punch-list/punch-list-items.component'
import { EquipmentReportComponent } from './equipment-report/equipment-report.component'
import { JobPoConfigurationComponent } from './job-po-configuration/job-po-configuration.component'
import { JobTypeVendorTemplatesComponent } from './job-type-vendor-templates/job-type-vendor-templates.component'
import { ForemanScheduleComponent } from './foreman-schedule/foreman-schedule.component'
import { SwpppComponent } from './swppp/swppp.component'
import { SwpppInspectionComponent } from './swppp/swppp-inspection.component'
import { SwpppSiteComponent } from './swppp/swppp-site.component'
import { PendingChangeOrdersPageComponent } from './pending-change-orders/pending-change-orders-page.component'
import { PendingChangeOrdersComponent } from './pending-change-orders/pending-change-orders.component'
import { PlansSpecsComponent } from './plans-specs/plans-specs.component'
import { PurchaseOrdersComponent } from './purchase-orders/purchase-orders.component'
import { QualityControlComponent } from './quality-control/quality-control.component'

export const fieldToolsRoutes: Routes = [
    {
        path: 'field-tools',
        children: [
            RouteUtil.Make('plans-and-specs', PlansSpecsComponent, FeatureType.FieldToolsPlansAndSpecsView),
            RouteUtil.Make('blue-stakes-log', BlueStakesLogsComponent, FeatureType.FieldToolsBlueStakesLogView),
            RouteUtil.Make('damaged-utility-log', DamagedUtilityLogComponent, [
                FeatureType.FieldToolsDamagedUtilityLogView,
                FeatureType.FieldToolsDamagedUtilityLogDashboardView,
            ]),
            RouteUtil.Make('punch-list', PunchListItemsComponent, FeatureType.FieldToolsPunchListView),
            RouteUtil.Make('purchase-orders', PurchaseOrdersComponent, FeatureType.FieldToolsPlansAndSpecsView),
            RouteUtil.Make('purchase-orders/list', PurchaseOrdersComponent, FeatureType.FieldToolsPlansAndSpecsView),
            RouteUtil.Make('quality-control', QualityControlComponent, FeatureType.FieldToolsPlansAndSpecsView),
            RouteUtil.Make('pending-change-orders', PendingChangeOrdersPageComponent, FeatureType.FieldToolsPendingChangeOrdersView),
            {
                path: 'pending-change-orders-field',
                component: PendingChangeOrdersComponent,
                canActivate: [RouteGuard],
                data: { feature: FeatureType.FieldToolsSiteConditionChangeView, voiceModal: true },
            },
            RouteUtil.Make('job-type-vendor-templates', JobTypeVendorTemplatesComponent, FeatureType.FieldToolsPoConfigEdit),
            RouteUtil.Make('job-po-configuration', JobPoConfigurationComponent, FeatureType.FieldToolsPoConfigView),
            RouteUtil.Make('equipment-report', EquipmentReportComponent, FeatureType.FieldToolsEquipmentReportView),
            RouteUtil.Make('equipment-report/list', EquipmentReportComponent, FeatureType.FieldToolsEquipmentReportView),
            RouteUtil.Make('foreman-schedule', ForemanScheduleComponent, FeatureType.FieldToolsForemanScheduleView),
            RouteUtil.Make('swppp', SwpppComponent, [FeatureType.FieldToolsSwpppView, FeatureType.FieldToolsSwpppDashboardView]),
            RouteUtil.Make('swppp/site/:id', SwpppSiteComponent, [FeatureType.FieldToolsSwpppView, FeatureType.FieldToolsSwpppDashboardView]),
            RouteUtil.Make('swppp/inspection/:id', SwpppInspectionComponent, [FeatureType.FieldToolsSwpppView, FeatureType.FieldToolsSwpppDashboardView]),
        ],
    },
]
